import { render } from "./Newbill.vue?vue&type=template&id=0e3a541a&scoped=true"
import script from "./Newbill.vue?vue&type=script&lang=js"
export * from "./Newbill.vue?vue&type=script&lang=js"

import "./Newbill.vue?vue&type=style&index=0&id=0e3a541a&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3a541a"]])

export default __exports__